//
// ┌─────────────────────┐
// │ DO NOT EDIT BY HAND │
// └─────────────────────┘
//
// Generated by build.mjs in zinnia-icons
//
import { mapPropsToSvgProps, Props } from "../utils";
function IconActionZapDetailsFill(iconProps: Props) {
  const props = mapPropsToSvgProps(iconProps);
  return <svg width={24} height={24} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}><path d="M15.5 2.10001V6.50001H19.9L15.5 2.10001Z" fill="currentColor" /><path fillRule="evenodd" clipRule="evenodd" d="M14 2V8H20V22H4V2H14ZM15.5586 13.1292L10.7502 18.8583V14.7958H8.44189L13.2502 9.06665V13.1292H15.5586Z" fill="currentColor" /></svg>;
}
export default IconActionZapDetailsFill;